import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout/Layout";
import FaqAccordian from "../components/sections/FaqPage/FaqAccordian/FaqAccordian";
const faq = ({ data }) => {
  console.log(data);
  return (
    <Layout title="FAQ">
      <FaqAccordian faqs={data.sanityFaqPage.faq} />
    </Layout>
  );
};

export const query = graphql`
  query FaqPageQuery($siteVariant: String) {
    sanityFaqPage(title: { eq: $siteVariant }) {
      faq {
        content
        title
      }
    }
  }
`;

export default faq;
